<nb-card class="dialog-card" [nbSpinner]="uploading">
  <nb-card-header>
    <h4>{{ "pages.skills.importDialog.title" | translate }}</h4>
  </nb-card-header>
  <nb-card-body>
    <nb-tabset (changeTab)="onTab($event)">
      <nb-tab tabId="file" [tabTitle]="'pages.skills.importDialog.tabFile' | translate" tabIcon="upload-outline">
        <label
          class="drop"
          [class.is-over]="dragging"
          (dragover)="$event.preventDefault(); dragging = true"
          (dragleave)="dragging = false"
          (drop)="drop($event)"
          [nbTooltip]="'pages.skills.importDialog.formatHint' | translate"
        >
          <nb-icon icon="upload-outline"></nb-icon>
          <span *ngIf="!file">{{ "pages.skills.importDialog.drop" | translate }}</span>
          <strong *ngIf="file">{{ file.name }}</strong>
          <input type="file" accept=".zip,.skill,.md" (change)="pick($event)" hidden />
        </label>
      </nb-tab>
      <nb-tab tabId="github" [tabTitle]="'pages.skills.importDialog.tabGithub' | translate" tabIcon="github-outline">
        <div class="form-field">
          <label class="label">
            {{ "pages.skills.importDialog.githubLabel" | translate }}
            <nb-icon icon="question-mark-circle-outline" class="hint-icon"
              nbPopover="{{ 'pages.skills.importDialog.githubHint' | translate }}" nbPopoverTrigger="hover"></nb-icon>
          </label>
          <input nbInput fullWidth fieldSize="small" type="url" [(ngModel)]="url" (ngModelChange)="onUrlChange()"
            placeholder="https://github.com/anthropics/skills/tree/main/skills/…" />
        </div>
        <ng-container *ngIf="candidates.length">
          <p class="hint">{{ "pages.skills.importDialog.pickHint" | translate: { count: candidates.length } }}</p>
          <nb-list class="candidates">
            <nb-list-item *ngFor="let c of candidates; trackBy: trackCandidate">
              <app-library-skill-item [skill]="c" mode="checkbox" [checked]="selected.has(c.path)"
                (checkedChange)="toggle(c.path, $event)"></app-library-skill-item>
            </nb-list-item>
          </nb-list>
        </ng-container>
      </nb-tab>
    </nb-tabset>
    <p class="hint">{{ "pages.skills.importDialog.inactiveNote" | translate }}</p>
    <div class="error-box" *ngIf="error" role="alert">
      <nb-icon icon="alert-circle-outline"></nb-icon>
      <span>{{ error }}</span>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton status="basic" size="small" type="button" (click)="close()">
      {{ "buttons.cancel" | translate }}
    </button>
    <button nbButton status="primary" size="small" type="button" (click)="confirm()" [disabled]="uploading"
      [nbTooltip]="(mode === 'github' ? 'pages.skills.importDialog.githubTooltip' : 'pages.skills.tooltips.upload') | translate">
      {{ (mode === "github"
            ? (candidates.length ? "pages.skills.importDialog.importSelected" : "pages.skills.importDialog.check")
            : "pages.skills.importDialog.upload") | translate: { count: selected.size } }}
    </button>
  </nb-card-footer>
</nb-card>
